import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import AuthModal from "@/components/auth/AuthModal";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ForYouFeed from "@/components/feed/ForYouFeed";
import FollowingFeed from "@/components/feed/FollowingFeed";
import SharedWithYouFeed from "@/components/feed/SharedWithYouFeed";
import WhatsHappening from "@/components/feed/WhatsHappening";
import WhoToFollow from "@/components/feed/WhoToFollow";
import UnifiedSearch from "@/components/search/UnifiedSearch";
import { PageHeader } from "@/components/ui/page-header";
import { PageShell } from "@/components/layout/PageShell";
import { T } from "@/i18n/T";
import { useT } from "@/i18n/useLocale";

const Feed = () => {
  const t = useT();
  const { isAuthenticated } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);

  if (!isAuthenticated) {
    return (
      <>
        <PageShell>
          <div className="flex flex-col items-center justify-center text-center py-16">
            <h2 className="text-2xl font-bold mb-2"><T k="auto.your-feed-awaits-8973" /></h2>
            <p className="text-muted-foreground mb-6 max-w-md">
              <T k="auto.sign-in-to-see-your-activity-feed-includ-752b" />
            </p>
            <Button onClick={() => setShowAuthModal(true)}><T k="auto.sign-in-f849" /></Button>
          </div>
        </PageShell>
        <AuthModal isOpen={showAuthModal} onClose={() => setShowAuthModal(false)} />
      </>
    );
  }

  return (
    <PageShell>
      <PageHeader
        eyebrow={t("auto.social-f431")}
        title={t("auto.your-feed-a02e")}
        description={t("auto.posts-comments-and-activity-from-people-fef8")}
      />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <Tabs defaultValue="for-you" className="w-full">
            <TabsList className="grid w-full grid-cols-3 max-w-2xl">
              <TabsTrigger value="for-you"><T k="auto.for-you-7e13" /></TabsTrigger>
              <TabsTrigger value="following"><T k="auto.following-90ee" /></TabsTrigger>
              <TabsTrigger value="shared"><T k="auto.shared-with-you-72f2" /></TabsTrigger>
            </TabsList>
            <TabsContent value="for-you" className="mt-6">
              <ForYouFeed />
            </TabsContent>
            <TabsContent value="following" className="mt-6">
              <FollowingFeed />
            </TabsContent>
            <TabsContent value="shared" className="mt-6">
              <SharedWithYouFeed />
            </TabsContent>
          </Tabs>
        </div>
        <aside className="hidden lg:block lg:col-span-1">
          <div className="sticky top-6 space-y-6">
            <UnifiedSearch mode="global" placeholder={t("auto.search-posts-people-839f")} />
            <WhatsHappening />
            <WhoToFollow />
          </div>
        </aside>
      </div>
    </PageShell>
  );
};

export default Feed;

